// extracted by mini-css-extract-plugin
export default {"privacyPolicyContainer":"PrivacyPolicyContent_privacyPolicyContainer__ER8mw"};